import React from 'react'
import styled from 'styled-components'

export const Header = () => {
	return(
		<StyledHeader>
		<h1>Email Signature Builder</h1>
		<strong>Step 1.</strong>
		<p>Use the panel on the left to customize your signature</p>
		</StyledHeader>
		)
}

const StyledHeader = styled.div`
margin-bottom: 4rem;
text-align: left;
h1 {
	font-size: 20px;
	margin: 1rem 0 3rem 0;
}
strong {
	font-weight: 500;
}
p {
	margin-top: 5px;
	margin-bottom: 0;
	line-height: 25px;
}
`
